module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/3ec8c94ad13df67fffaa41e5f31baaf9.png";